



















import mixins from 'vue-typed-mixins';
import cloneDeep from 'lodash.clonedeep';
import ProviderForm from '@/components/provider/ProviderForm.vue';
import ProviderUtils, { ServiceProvider } from '../../utils/ProviderUtils';
export default mixins().extend({
  components: {
    ProviderForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    provider?: Partial<ServiceProvider>;
  } {
    return {
      provider: {
        name: this.$languageobj(),
        serviceprovidertype: undefined,
        parent: undefined,
      },
    };
  },
  methods: {
    async submit() {
      if (this.provider) {
        try {
          this.$alert.hide('submit');

          await ProviderUtils.api.instance.add(
            this.provider as ServiceProvider
          );
          await this.$router.push({ name: 'provider-list' });

          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.provider.name],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
